/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  NoteAdminDeleteReqVo,
  NoteDeleteReqVo,
  NoteReadReqVo,
  NoteSendReqVo,
  NoteUpdateReqVo,
  ResponseInteger,
  ResponseNoteVo,
  ResponsePageDataNoteVo,
  ResponseString,
} from '../models/index';
import {
    NoteAdminDeleteReqVoFromJSON,
    NoteAdminDeleteReqVoToJSON,
    NoteDeleteReqVoFromJSON,
    NoteDeleteReqVoToJSON,
    NoteReadReqVoFromJSON,
    NoteReadReqVoToJSON,
    NoteSendReqVoFromJSON,
    NoteSendReqVoToJSON,
    NoteUpdateReqVoFromJSON,
    NoteUpdateReqVoToJSON,
    ResponseIntegerFromJSON,
    ResponseIntegerToJSON,
    ResponseNoteVoFromJSON,
    ResponseNoteVoToJSON,
    ResponsePageDataNoteVoFromJSON,
    ResponsePageDataNoteVoToJSON,
    ResponseStringFromJSON,
    ResponseStringToJSON,
} from '../models/index';

export interface NoteAdminDeleteDeleteRequest {
    noteAdminDeleteReqVo?: NoteAdminDeleteReqVo;
}

export interface NoteDeleteDeleteRequest {
    noteDeleteReqVo?: NoteDeleteReqVo;
}

export interface NoteIdGetRequest {
    id: number;
}

export interface NoteListGetRequest {
    currentPage?: number;
    pageSize?: number;
    mobileNo?: string;
    receiverId?: number;
    receiverName?: string;
    title?: string;
    content?: string;
    orderCode?: string;
    noteStatus?: string;
    startTime?: string;
    endTime?: string;
}

export interface NoteMyListGetRequest {
    currentPage?: number;
    pageSize?: number;
    noteStatus?: string;
    startTime?: string;
    endTime?: string;
}

export interface NoteReadPutRequest {
    noteReadReqVo?: NoteReadReqVo;
}

export interface NoteSendPostRequest {
    noteSendReqVo?: NoteSendReqVo;
}

export interface NoteUpdatePutRequest {
    noteUpdateReqVo?: NoteUpdateReqVo;
}

/**
 * 
 */
export class NoteControllerApi extends runtime.BaseAPI {

    /**
     * 
     * 管理员删除站内信（逻辑删除，无需验证接收者）
     */
    async noteAdminDeleteDeleteRaw(requestParameters: NoteAdminDeleteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/admin/delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: NoteAdminDeleteReqVoToJSON(requestParameters['noteAdminDeleteReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 管理员删除站内信（逻辑删除，无需验证接收者）
     */
    async noteAdminDeleteDelete(requestParameters: NoteAdminDeleteDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.noteAdminDeleteDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 删除站内信（逻辑删除）
     */
    async noteDeleteDeleteRaw(requestParameters: NoteDeleteDeleteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/delete`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: NoteDeleteReqVoToJSON(requestParameters['noteDeleteReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 删除站内信（逻辑删除）
     */
    async noteDeleteDelete(requestParameters: NoteDeleteDeleteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.noteDeleteDeleteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 根据ID获取站内信详情
     */
    async noteIdGetRaw(requestParameters: NoteIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseNoteVo>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling noteIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseNoteVoFromJSON(jsonValue));
    }

    /**
     * 
     * 根据ID获取站内信详情
     */
    async noteIdGet(requestParameters: NoteIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseNoteVo> {
        const response = await this.noteIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取站内信列表（分页）
     */
    async noteListGetRaw(requestParameters: NoteListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataNoteVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['mobileNo'] != null) {
            queryParameters['mobileNo'] = requestParameters['mobileNo'];
        }

        if (requestParameters['receiverId'] != null) {
            queryParameters['receiverId'] = requestParameters['receiverId'];
        }

        if (requestParameters['receiverName'] != null) {
            queryParameters['receiverName'] = requestParameters['receiverName'];
        }

        if (requestParameters['title'] != null) {
            queryParameters['title'] = requestParameters['title'];
        }

        if (requestParameters['content'] != null) {
            queryParameters['content'] = requestParameters['content'];
        }

        if (requestParameters['orderCode'] != null) {
            queryParameters['orderCode'] = requestParameters['orderCode'];
        }

        if (requestParameters['noteStatus'] != null) {
            queryParameters['noteStatus'] = requestParameters['noteStatus'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataNoteVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取站内信列表（分页）
     */
    async noteListGet(requestParameters: NoteListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataNoteVo> {
        const response = await this.noteListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 获取当前用户的站内信列表（分页）
     */
    async noteMyListGetRaw(requestParameters: NoteMyListGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponsePageDataNoteVo>> {
        const queryParameters: any = {};

        if (requestParameters['currentPage'] != null) {
            queryParameters['currentPage'] = requestParameters['currentPage'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['noteStatus'] != null) {
            queryParameters['noteStatus'] = requestParameters['noteStatus'];
        }

        if (requestParameters['startTime'] != null) {
            queryParameters['startTime'] = requestParameters['startTime'];
        }

        if (requestParameters['endTime'] != null) {
            queryParameters['endTime'] = requestParameters['endTime'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/my-list`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponsePageDataNoteVoFromJSON(jsonValue));
    }

    /**
     * 
     * 获取当前用户的站内信列表（分页）
     */
    async noteMyListGet(requestParameters: NoteMyListGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponsePageDataNoteVo> {
        const response = await this.noteMyListGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 标记站内信为已读
     */
    async noteReadPutRaw(requestParameters: NoteReadPutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/read`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NoteReadReqVoToJSON(requestParameters['noteReadReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 标记站内信为已读
     */
    async noteReadPut(requestParameters: NoteReadPutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.noteReadPutRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 发送站内信（支持指定用户或按等级群发）
     */
    async noteSendPostRaw(requestParameters: NoteSendPostRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseInteger>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/send`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NoteSendReqVoToJSON(requestParameters['noteSendReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseIntegerFromJSON(jsonValue));
    }

    /**
     * 
     * 发送站内信（支持指定用户或按等级群发）
     */
    async noteSendPost(requestParameters: NoteSendPostRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseInteger> {
        const response = await this.noteSendPostRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 
     * 更新站内信标题和内容
     */
    async noteUpdatePutRaw(requestParameters: NoteUpdatePutRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResponseString>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/note/update`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: NoteUpdateReqVoToJSON(requestParameters['noteUpdateReqVo']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResponseStringFromJSON(jsonValue));
    }

    /**
     * 
     * 更新站内信标题和内容
     */
    async noteUpdatePut(requestParameters: NoteUpdatePutRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResponseString> {
        const response = await this.noteUpdatePutRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
